import { render, staticRenderFns } from "./PostInform.vue?vue&type=template&id=032b0e97&scoped=true&"
import script from "./PostInform.vue?vue&type=script&lang=js&"
export * from "./PostInform.vue?vue&type=script&lang=js&"
import style0 from "./PostInform.vue?vue&type=style&index=0&id=032b0e97&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032b0e97",
  null
  
)

export default component.exports